/**
 * ReactQuill wrapper that avoids deprecated findDOMNode.
 * When the editing area ref is a DOM element (e.g. a div), we use it directly
 * instead of calling ReactDOM.findDOMNode.
 */
import ReactQuill from "react-quill";

const originalGetEditingArea = ReactQuill.prototype.getEditingArea;
ReactQuill.prototype.getEditingArea = function getEditingArea() {
  if (!this.editingArea) {
    throw new Error("Instantiating on missing editing area");
  }
  // Ref on a DOM element is the element itself; avoid findDOMNode when possible
  const element =
    this.editingArea?.nodeType != null
      ? this.editingArea
      : originalGetEditingArea.call(this);
  if (!element) {
    throw new Error("Cannot find element for editing area");
  }
  if (element.nodeType === 3) {
    throw new Error("Editing area cannot be a text node");
  }
  return element;
};

export default ReactQuill;
